import React from 'react';
import { ReportTimeFrame } from '@tribeplatform/gql-client/types';
import { PagePicker } from '@tribeplatform/react-components/EntityPicker';
import { T, useStaticIntl } from '@tribeplatform/react-components/i18n';
import { useSpace } from '@tribeplatform/react-sdk/hooks';
import { useBlock, useSlate } from '@tribeplatform/react-slate-kit/hooks';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { DEFAULT_MEMBERS_COUNT, leaderboardTabsFactory, MAX_MEMBERS_COUNT, } from './constants.js';
export const LeaderboardBlockSettings = () => {
    const { block: { props: { heading, spaceId, membersCount, excludeStaff = false, defaultTab = ReportTimeFrame.allTime, showScore = true, }, }, upsertProp, } = useBlock();
    const { context: { spaceId: slateSpaceId }, } = useSlate();
    const { data: space } = useSpace({
        fields: {
            image: 'basic',
        },
        variables: { id: spaceId },
        useQueryOptions: {
            enabled: !!spaceId,
        },
    });
    const leaderboardTabs = useStaticIntl(leaderboardTabsFactory);
    return (React.createElement("div", { className: "grid grid-cols-1 gap-5" },
        React.createElement(FormControl.Input, { name: "heading", label: React.createElement(T, { id: "Generics.Heading", defaultMessage: "Heading" }), value: heading, onChange: e => upsertProp('heading', e.target.value) }),
        React.createElement("div", { className: "space-y-1" },
            React.createElement(FormControl.Label, null,
                React.createElement(T, { defaultMessage: "Source", id: "Generics.Source" })),
            React.createElement(PagePicker, { initialPage: Object.assign(Object.assign({}, space), { id: spaceId || null }), currentSpaceId: slateSpaceId, onSelect: newSpace => {
                    var _a;
                    upsertProp('spaceId', (_a = newSpace === null || newSpace === void 0 ? void 0 : newSpace.id) !== null && _a !== void 0 ? _a : '');
                } })),
        React.createElement(FormControl.Input, { name: "membersCount", type: "number", min: "1", max: MAX_MEMBERS_COUNT, label: React.createElement(T, { id: "Blocks.Leaderboard.MemberCountLabel", defaultMessage: "Number of {MEMBERS}" }), value: membersCount, placeholder: `${DEFAULT_MEMBERS_COUNT}`, onChange: e => {
                const number = parseInt(e.target.value, 10) || null;
                upsertProp('membersCount', number > MAX_MEMBERS_COUNT ? MAX_MEMBERS_COUNT : number);
            } }),
        React.createElement(FormControl.Select, { name: "defaultTab", value: defaultTab, onChange: (value) => {
                upsertProp('defaultTab', value);
                return value;
            }, label: React.createElement(T, { id: "Blocks.Leaderboard.DefaultTabLabel", defaultMessage: "Default tab" }), items: leaderboardTabs, helperText: React.createElement(T, { id: "Blocks.Leaderboard.HelperText", defaultMessage: "Changes will not show up in the preview" }) }),
        React.createElement(FormControl.Toggle, { name: "showScore", label: React.createElement(T, { id: "Block.Leaderboard.ShowScoreToggle", defaultMessage: "Show score" }), checked: showScore, onChange: value => {
                upsertProp('showScore', value);
            } }),
        React.createElement(FormControl.Toggle, { name: "excludeStaff", label: React.createElement(T, { id: "Blocks.Leaderboard.ExcludeStaffToggleLabel", defaultMessage: "Exclude admins & moderators" }), checked: excludeStaff, onChange: value => {
                upsertProp('excludeStaff', value);
            } })));
};
//# sourceMappingURL=Settings.js.map